import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { useTranslation } from "@/i18n/translations";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_payment-links-hub-1/artifacts/qmtwufa4_test%20logo%20.jpg";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer data-testid="footer" className="bg-[#1B2B5B] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <div className="mb-4">
              <span className="text-2xl font-bold text-white tracking-tight" style={{fontFamily: 'Outfit, sans-serif'}}>
                <span className="text-[#00C853]">Aya</span>Pay
              </span>
            </div>
            <p className="text-slate-300 text-sm leading-relaxed">
              {t("footer.desc")}
            </p>
          </div>

          {/* Solutions */}
          <div>
            <h4 className="font-semibold text-sm tracking-wide uppercase text-slate-300 mb-4">{t("footer.solutions")}</h4>
            <ul className="space-y-2.5">
              <li><Link to="/solutions" className="text-sm text-slate-400 hover:text-white transition-colors">{t("features.terminals")}</Link></li>
              <li><Link to="/solutions" className="text-sm text-slate-400 hover:text-white transition-colors">{t("features.online")}</Link></li>
              <li><Link to="/solutions" className="text-sm text-slate-400 hover:text-white transition-colors">{t("features.links")}</Link></li>
              <li><Link to="/pos" className="text-sm text-slate-400 hover:text-white transition-colors">AyaPOS</Link></li>
            </ul>
          </div>

          {/* Entreprise */}
          <div>
            <h4 className="font-semibold text-sm tracking-wide uppercase text-slate-300 mb-4">{t("footer.company")}</h4>
            <ul className="space-y-2.5">
              <li><Link to="/a-propos" className="text-sm text-slate-400 hover:text-white transition-colors">{t("nav.about")}</Link></li>
              <li><Link to="/tarifs" className="text-sm text-slate-400 hover:text-white transition-colors">{t("nav.pricing")}</Link></li>
              <li><Link to="/faq" className="text-sm text-slate-400 hover:text-white transition-colors">FAQ</Link></li>
              <li><Link to="/contact" className="text-sm text-slate-400 hover:text-white transition-colors">{t("nav.contact")}</Link></li>
              <li><a href="https://pay.ayapay.ch" target="_blank" rel="noopener noreferrer" className="text-sm text-slate-400 hover:text-white transition-colors">{t("nav.client")}</a></li>
              <li><Link to="/conditions-generales" className="text-sm text-slate-400 hover:text-white transition-colors">Conditions generales</Link></li>
              <li><Link to="/conformite" className="text-sm text-slate-400 hover:text-white transition-colors">Conformite & legal</Link></li>
              <li><Link to="/partenaires" className="text-sm text-slate-400 hover:text-white transition-colors">Devenir partenaire</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-sm tracking-wide uppercase text-slate-300 mb-4">{t("footer.contact")}</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2.5">
                <MapPin size={16} className="text-[#00C853] mt-0.5 shrink-0" />
                <span className="text-sm text-slate-400">Chemin des Lilas 12, 2503 Biel / Suisse</span>
              </li>
              <li className="flex items-center gap-2.5">
                <Mail size={16} className="text-[#00C853] shrink-0" />
                <a href="mailto:contact@ayapay.ch" className="text-sm text-slate-400 hover:text-white transition-colors">contact@ayapay.ch</a>
              </li>
              <li className="flex items-center gap-2.5">
                <Phone size={16} className="text-[#00C853] shrink-0" />
                <a href="tel:+41762003612" className="text-sm text-slate-400 hover:text-white transition-colors">+41 76 200 36 12</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-700 mt-12 pt-8 flex flex-col gap-6">
          {/* Local SEO links — improves indexing for city-based searches */}
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-slate-500">
            <span className="uppercase tracking-wide text-slate-400">Régions :</span>
            <Link to="/terminal-paiement-geneve" className="hover:text-white transition-colors">Genève</Link>
            <span className="text-slate-700">·</span>
            <Link to="/terminal-paiement-lausanne" className="hover:text-white transition-colors">Lausanne</Link>
            <span className="text-slate-700">·</span>
            <Link to="/terminal-paiement-zurich" className="hover:text-white transition-colors">Zürich</Link>
            <span className="text-slate-700">·</span>
            <span>Berne</span>
            <span className="text-slate-700">·</span>
            <span>Bâle</span>
            <span className="text-slate-700">·</span>
            <span>Bienne</span>
            <span className="text-slate-700">·</span>
            <span>Lugano</span>
            <span className="text-slate-700">·</span>
            <span>Sion</span>
          </div>
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-slate-500">&copy; {new Date().getFullYear()} AyaPay by AYAPOS. {t("footer.rights")}</p>
            <div className="flex items-center gap-6">
              <span className="text-xs text-slate-500">{t("footer.certified")}</span>
              <span className="text-xs text-slate-500">{t("footer.swiss")}</span>
              <Link to="/admin/login" className="text-xs text-slate-600 hover:text-slate-300 transition-colors">Admin</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
